// Formatter functions for Devices Module

export const formatDate = (
  timestamp: { _seconds: number; _nanoseconds: number } | undefined | null
): string => {
  if (!timestamp || !timestamp._seconds) return "N/A";
  const date = new Date(timestamp._seconds * 1000);
  return date.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export interface TimeUntilTranslations {
  alreadyPassed: string;
  inDays: string;
  inDaysPlural: string;
  inHours: string;
  inHoursPlural: string;
  inMinutes: string;
  inMinutesPlural: string;
  inSeconds: string;
}

const defaultTimeUntilTranslations: TimeUntilTranslations = {
  alreadyPassed: "ya pasó",
  inDays: "en {{count}} día",
  inDaysPlural: "en {{count}} días",
  inHours: "en {{count}} hora",
  inHoursPlural: "en {{count}} horas",
  inMinutes: "en {{count}} minuto",
  inMinutesPlural: "en {{count}} minutos",
  inSeconds: "en unos segundos",
};

export const getTimeUntil = (seconds: number, nanoseconds?: number, translations?: TimeUntilTranslations): string => {
  const t = translations || defaultTimeUntilTranslations;
  const timestamp = seconds * 1000 + (nanoseconds ? nanoseconds / 1_000_000 : 0);
  const now = Date.now();
  const diff = timestamp - now;

  if (diff <= 0) return t.alreadyPassed;

  const totalSeconds = Math.floor(diff / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return (days > 1 ? t.inDaysPlural : t.inDays).replace("{{count}}", String(days));
  if (hours > 0) return (hours > 1 ? t.inHoursPlural : t.inHours).replace("{{count}}", String(hours));
  if (minutes > 0) return (minutes > 1 ? t.inMinutesPlural : t.inMinutes).replace("{{count}}", String(minutes));
  return t.inSeconds;
};

export const formatNumber = (
  value: number | undefined,
  suffix: string = ""
): string => {
  if (value === undefined || value === null) return "N/A";
  return `${value}${suffix}`;
};

export const formatPercentage = (value: number | undefined): string => {
  if (value === undefined || value === null) return "N/A";
  return `${value}%`;
};

export const formatIndexNumber = (index: number): string => {
  return index.toString().padStart(3, "0");
};
